export type PasswordRule = {
  label: string;
  test: (value: string) => boolean;
};

export const passwordRules: PasswordRule[] = [
  {
    label: 'Minimum 8 characters',
    test: (value) => value.length >= 8,
  },
  {
    label: 'Includes uppercase and lowercase letters',
    test: (value) => /[A-Z]/.test(value) && /[a-z]/.test(value),
  },
  {
    label: 'Must contain numbers',
    test: (value) => /\d/.test(value),
  },
  {
    label: 'Must contain special characters',
    test: (value) => /[!@#$%^&*(),.?":{}|<>]/.test(value),
  },
  {
    label: 'No spaces allowed',
    test: (value) => !/\s/.test(value),
  },
];

export function isPasswordValid(password: string) {
  return passwordRules.every((rule) => rule.test(password));
}
